module.exports = __webpack_public_path__ + "img/cash.56fc5619.jpg";